import React from 'react';
import cx from 'classnames';
import CommonFooter from '@src/business-components/common-footer';
import CommonFooterStore from '@src/business-components/common-footer/store';
import { getLocales } from '@src/global-locales/get-page-locales-data';
const styles = require('./index.less');
const BUTTONS = ['backTop', 'scrollDownTip', 'copyright'];

/**
 * @param {string} position: sticky | fixed
 * @param {string} theme: dark | light | yellow
 * @param {array} btns: ['backTop', 'scrollDownTip', 'copyright']
 */
export default ({ btns = BUTTONS, showBtnBackTop, onBackTop, className, theme = 'dark', position = 'sticky' }) => {
  const [isShowBackTop, setIsShowBackTop] = React.useState(showBtnBackTop);
  const [isActive, setIsActive] = React.useState(false);

  const commonFooterStore = React.useMemo(
    () =>
      new CommonFooterStore({
        isActive: false,
        showToTopBtn: true,
        scrollToTop: () => {
          backTop();
        }
      }),
    []
  );

  React.useEffect(() => {
    if (!onBackTop) {
      const handleScroll = () => {
        setIsShowBackTop(window.scrollY > 0);
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  React.useEffect(
    () => {
      onBackTop && setIsShowBackTop(showBtnBackTop);
    },
    [showBtnBackTop]
  );

  const backTop = () => {
    if (!onBackTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      onBackTop();
    }
    setIsActive(false);
  };

  const showCopyRight = () => {
    setIsActive(!isActive);
  };

  const renderButton = btn => {
    if (!btns.includes(btn)) {
      return null;
    }

    switch (btn) {
      case 'backTop':
        return <div className={styles.btnBackTop} onClick={backTop} />;
      case 'scrollDownTip':
        return <div className={styles.scrollDown} />;
      case 'copyright':
        return (
          <div className={styles.btnCopyright} onClick={showCopyRight}>
            {getLocales('common_footer.copyright_btn')}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={cx(styles.footerRoot, styles[position], { [styles.isActive]: isActive })}>
      <section className={cx(styles.footer, styles[theme], className)}>
        <div className={cx(styles.footerInner, { [styles.showBtnBackTop]: isShowBackTop })}>
          {renderButton('scrollDownTip')}
          {renderButton('backTop')}
          {renderButton('copyright')}
        </div>
        {/* 使用sticky，父元素不能设置 overflow: hidden; */}
        {position === 'sticky' && <style>{'#pc-layout-main { overflow: visible }'}</style>}
      </section>
      {btns.includes('copyright') && (
        <div className={styles.copyRightFooter}>
          <CommonFooter store={commonFooterStore} />
        </div>
      )}
    </div>
  );
};
